import { useMemo } from 'react';
import { Banner, ListCoverStories } from '@components';
import { GetCoverStoriesQuery } from '@graphqlTypes';
import AlbumDescBlock from './AlbumDescBlock/AlbumDescBlock';

// Styles
import styles from './CoverStoryEndScreen.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

// Debug
import { useDebug } from "@/utils/useDebugLog";

interface CoverStoryProps {
  options: CoverStoryOptions;
  gameData: CoverStoryGameData;
  coverStories: GetCoverStoriesQuery['coverStories'];
  pageUri?: string;
}

export default function CoverStoryEndScreen({ coverStories, gameData, options, pageUri }: CoverStoryProps) {
  const { log } = useDebug({ name: 'CoverStoryEndScreen', bgColor: '#D92929', textColor: 'white', enabled: false });

  const { coverStoryListHeadline, coverStoryListSubhead, coverStoryListLabels, coverStoryEndScreenBanner } = options;
  const { artistFeature: { body, cta, image }, databaseId } = gameData;
  const bodyText = useMemo(() => body?.map(item => ({ text: item.text})) || [], [body]);
  const featureCta = useMemo(() =>
    cta ? (cta as Omit<typeof cta, '__typename'>) : null,
  [cta]);

  log({ gameData, options, coverStories, bodyText, featureCta });

  // -------------------- Render

  return (
    <section className={cx(["cover-story-end-screen"])}>
      <AlbumDescBlock
        className={cx("cover-story-end-feature")}
        artifactSingularHeadline={[{ line: 'Cover'}, { line: '**Story**' }]}
        artifactSingularBody={bodyText}
        image={image}
        cta={featureCta}
      />
      <Banner {...coverStoryEndScreenBanner} />
      <ListCoverStories
        coverStories={coverStories}
        notIn={[databaseId]}
        headline={coverStoryListHeadline}
        subhead={coverStoryListSubhead}
        labels={coverStoryListLabels}
        pageUri={pageUri}
      />
    </section>
  );

}
